<template>
    <div id="right-panel" class="right-panel fContainer">
        <SellHeader></SellHeader>
        <div class="content mt-3 fColumn">
            <div class="animated fadeIn fColumn">
                <div class="card     fColumn ">
                    <div class="card-header     fHead">
                        <strong>{{$t('transactions.title')}}</strong>
                        <div class="float-right">
                        </div>
                    </div>
                    <div class="fContent">
                        <div class="card-body card-block ">
                            <form action="" method="post" class="">
                                <div class="hiddenSzb">
                                    <input type="text" name="del">
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-lg-6">
                                        <TransactionsOpeningBalance></TransactionsOpeningBalance>
                                    </div>
                                    <div class="col-md-12 col-lg-6">
                                        <TransactionsCloseingBalance></TransactionsCloseingBalance>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-md-12 col-lg-6">--
                                        <TransactionsExtraIncome></TransactionsExtraIncome>
                                    </div>
                                    <div class="col-md-12 col-lg-6">
                                        <TransactionsExpense></TransactionsExpense>
                                    </div>
                                </div>
                                <hr>

                                <div class="row">
                                    <div class="col-md-12 col-lg-6">
                                        <TransactionsExtraIncomeCashregisteroff></TransactionsExtraIncomeCashregisteroff>
                                    </div>
                                    <div class="col-md-12 col-lg-6">
                                        <TransactionsExpenseCashregisteroff></TransactionsExpenseCashregisteroff>
                                    </div>
                                </div>
                                <hr>

                                <TransactionsScrapping></TransactionsScrapping>
                            </form>
                        </div>
                    </div>
                    <div class="card-footer text-center fFix">
                    </div>
                </div>
            </div><!-- .animated -->
        </div><!-- .content -->
    </div>
</template>


<script>
    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
//    import dbh from '@/helper/dbh';
    import InputText from '@/components/InputText.vue';
    import TransactionsOpeningBalance from '@/components/TransactionsOpeningBalance.vue';
    import TransactionsCloseingBalance from '@/components/TransactionsCloseingBalance.vue';
    import TransactionsExtraIncome from '@/components/TransactionsExtraIncome.vue';
    import TransactionsExtraIncomeCashregisteroff from '@/components/TransactionsExtraIncomeCashregisteroff.vue';
    import TransactionsExpense from '@/components/TransactionsExpense.vue';
    import TransactionsExpenseCashregisteroff from '@/components/TransactionsExpenseCashregisteroff.vue';
    import TransactionsScrapping from '@/components/TransactionsScrapping.vue';
    import SellHeader from "../components/SellHeader";

    export default {
        name: 'Transactions',
        data() {
            return {};
        },
        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }

        },
        methods: {},
        components: {
            SellHeader,
            InputText,
            LngChooser,
            AlertInPage,
            TransactionsOpeningBalance,
            TransactionsCloseingBalance,
            TransactionsExtraIncome,
            TransactionsExtraIncomeCashregisteroff,
            TransactionsExpense,
            TransactionsExpenseCashregisteroff,
            TransactionsScrapping,
        },
    };
</script>

